if (document.querySelectorAll('.has__tooltip').length > 0) {
	document.querySelectorAll('.has__tooltip').forEach((element) => {
		element.addEventListener('click', (e) => {
			function checkMediaQuery(x) {
				if (x.matches) {
					if (element.classList.contains('has__tooltip')) {
						element.querySelector('tooltip').classList.toggle('is-visible');
					}
				}
			}

			var x = window.matchMedia('(max-width: 640px)');
			checkMediaQuery(x);
			x.addListener(checkMediaQuery);
		});
	});
}
